"use client"

import type { ReactNode } from "react"

import Image from "next/image"
import { useTranslations } from "next-intl"

import { Spinner } from "@/components/ui/spinner"
import { onboardingFrameCard, onboardingFramePage } from "@/features/checkout/redesign/onboarding-frame"

// The page the next screen sits on, so a short wait reads as that screen arriving: its header's logo, where the header puts it,
// from the first paint; the spinner fades in only once the wait is long enough to notice.
export const LoadingScreen = ({ testId, leading }: { testId?: string; leading?: ReactNode }) => {
  const t = useTranslations("common")

  return (
    <section role="status" aria-label={t("loading")} data-testid={testId} className={`bg-surface-flow flex min-h-screen flex-1 flex-col ${onboardingFramePage}`}>
      <div className={`max-w-onboarding pt-safe-offset-500 mx-auto flex w-full flex-1 flex-col ${onboardingFrameCard}`}>
        <div className="relative flex h-10 items-center justify-center">
          {leading && <div className="absolute inset-y-0 left-0 flex items-center">{leading}</div>}
          <Image src="/images/nelo_logo_web.svg" alt="" width={68} height={30} loading="eager" />
        </div>
        <div className="flex flex-1 items-center justify-center">
          <span aria-hidden className="onboarding-loading-indicator">
            <Spinner aria-hidden role={undefined} className="text-brand size-6.5" />
          </span>
        </div>
      </div>
    </section>
  )
}
